// Docs JS bundle. Standalone from application.js and marketing.js.
import { Application } from "@hotwired/stimulus";
import "@hotwired/turbo-rails";

import ClipboardController from "./controllers/clipboard_controller";

const Stimulus = Application.start();
Stimulus.debug = false;

Stimulus.register("clipboard", ClipboardController);
